var React = require('react');

function IconB3Email (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("circle",{"fill":"#A1BF36","cx":"16.001","cy":"16","r":"16.001","key":0}),React.createElement("path",{"fill":"#FFFFFF","d":"M23.462,10.352H8.539c-0.286,0-0.515,0.229-0.515,0.515v10.267c0,0.284,0.229,0.515,0.515,0.515h14.923\n\t\tc0.285,0,0.515-0.231,0.515-0.515V10.867C23.976,10.581,23.746,10.352,23.462,10.352z M16.007,16.733l-6.1-5.35h12.188\n\t\tL16.007,16.733z M13.609,16.001l-4.555,3.996v-7.993L13.609,16.001z M14.391,16.687l1.274,1.119\n\t\tc0.098,0.084,0.22,0.127,0.341,0.127c0.12,0,0.243-0.043,0.339-0.129l1.274-1.117l4.475,3.932H9.908L14.391,16.687z M18.4,16.001\n\t\tl4.546-3.997v7.991L18.4,16.001z","key":1})]));
}

IconB3Email.displayName = "IconB3Email";

IconB3Email.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 32 32","enableBackground":"new 0 0 32 32","xmlSpace":"preserve"};

module.exports = IconB3Email;

IconB3Email.default = IconB3Email;
